import EfSection from '@elem/ui/ef-section';
import { useProductStore } from '../../ProductProvider';
import { PAGE_TYPE } from '../../constants';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionD');
    const { pageType } = useProductStore();
    const BG_MAP: any = {
        [PAGE_TYPE.BASE]: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1726039678977/pc_SectionD_base.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1726039686976/m_SectionD_base.jpg',
        },
        [PAGE_TYPE.MOTOR]: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725605169988/pc_Small%20Size.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725605259090/m_Small%20Size.jpg',
        },
    };
    const bg = BG_MAP[pageType];

    return (
        <div className={styles.TheComp}>
            <EfSection pc={bg.pc} h5={bg.h5} label={t('label')} title={t('title')} desc={t('desc')} />
        </div>
    );
}
